import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.20_@babel+core@7.25.2_@opentelemetry+api@1.9.0_@playwright+test@1.46.1_babel-plugin_bb6q7lkkvwf4lil4btetidfyfy/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/features/auth/src/components/sign-up-methods-container.tsx");
